import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import HighSchoolTranscriptTypeService from "../../src/Services/HighSchoolTranscriptType.service";
import LookupGeneric from "./lookupGeneric";
const HighSchoolTranscriptTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            return HighSchoolTranscriptTypeService.findByIds(ids);
        },
        fetchOptions: (query) => {
            return HighSchoolTranscriptTypeService.search({
                query,
                active: true, // if HighSchoolTranscriptType has an active field for this purpose
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(highSchoolTranscriptType) {
            return _jsx("span", { children: highSchoolTranscriptType.name });
        },
    });
};
export default HighSchoolTranscriptTypeLookup;
